import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import I18n from 'i18n-js'
import { useSelector } from 'react-redux'
import { makeStyles } from 'tss-react/mui'

import { createR1UrlBasePath } from '../../../../lib/Utils'
import { selectors } from '../../../../stores'

const useStyles = makeStyles()((theme) => {
  return {
    root: {
      'display': 'flex',
      'padding': theme.spacing(2),
      'cursor': 'pointer',
      '&:hover': {
        background: theme.palette.grey[200],
      },
      'textDecoration': 'none',
    },
  }
})

const LocalAd = ({ name, localAd, currentSlugs }) => {
  const { classes } = useStyles()
  return (
    <Box
      className={classes.root}
      color="inherit"
      component="a"
      data-testid={`${name}Container`}
      href={`/#${createR1UrlBasePath(
        currentSlugs.retailerAccount,
        localAd.brandSlug,
      )}ads`}
    >
      <Box
        component="img"
        style={{ objectFit: 'cover' }}
        data-testid={`${name}LocalAdsImage`}
        height={90}
        src={localAd.logoUrl}
        width={90}
      />
      <Box paddingLeft={4}>
        <Box
          data-testid={`${name}LocalAdsTitle`}
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          width="160px"
        >
          <strong>{localAd.campaignName}</strong>
        </Box>
        <Typography data-testid={`${name}LocalAdsBrand`}>
          {localAd.brandName}
        </Typography>

        <Typography
          data-testid={`${name}LocalAdsFunds`}
          style={{ color: 'green' }}
        >
          <strong>{localAd.balance}</strong>
        </Typography>
        <Typography data-testid={`${name}LocalAdsExpires`} variant="body2">
          <strong>{I18n.t('wallet.expires')}</strong> {localAd.expirationDate}
        </Typography>
      </Box>
    </Box>
  )
}

const LocalAds = ({ name, localAdsTotal }) => {
  const { brandAllocationDetails } = useSelector(
    selectors.retailerAccountAllocationDetails
      .allocationDetailsForWalletSelector,
  )
  const { currentSlugs } = useSelector(
    selectors.app.selectCurrentRetailerAccountAndBrandSlug,
  )
  return (
    <Box maxHeight={370} padding={4}>
      <Box
        alignItems="center"
        column
        data-testid={`${name}LocalAdsDropdownTitle`}
        display="flex"
        flexDirection="column"
        marginBottom={2}
        minWidth="260px"
      >
        <Box fontSize="h6.fontSize" fontWeight="600" margin={4}>
          {I18n.t('wallet.localAdsTotal')}
          <Box color={'green'} component="span">
            {localAdsTotal}
          </Box>
        </Box>
      </Box>
      {!brandAllocationDetails.length && (
        <Box
          data-testid={`${name}NoCamapaignText`}
          fontSize="body2.fontSize"
          fontStyle="italic"
          textAlign="center"
        >
          {I18n.t('wallet.noLocalAds')}
        </Box>
      )}
      {brandAllocationDetails.map((localAd) => (
        <LocalAd
          currentSlugs={currentSlugs}
          localAd={localAd}
          name={`${name}-${localAd.id}`}
        />
      ))}
    </Box>
  )
}

export default LocalAds
